'use strict';

// ドロップダウンメニュー（見た目は components/_dropdown.scss）
// マークアップ:
//   .app-dropdown.js-dropdown
//     %button.js-dropdown-toggle{ type: 'button', 'aria-expanded': 'false', 'aria-haspopup': 'true', 'aria-controls': 'menu-id' }
//     %ul#menu-id.app-dropdown__menu
//       %li= link_to '...', path, class: 'app-dropdown__item'
// - ボタンで開閉し、メニューの外のクリック・Esc・フォーカスが外へ出たときに閉じる。同時に開くのは 1 つだけ
// - 開いている間は ↑↓ / Home / End で項目を移動できる
// - 開閉のたびに .js-dropdown へ app-dropdown:show / app-dropdown:hide を発火する（向きの付け替えなどに使う）
// document へのイベント委譲なので turbolinks:load の外で 1 回だけ登録する
(function () {
  const OPEN_CLASS = 'is-open';
  const ITEM_SELECTOR = '.app-dropdown__item:not([disabled])';

  function toggleButton($dropdown) {
    return $dropdown.children('.js-dropdown-toggle').first();
  }

  function items($dropdown) {
    return $dropdown.find(ITEM_SELECTOR).filter(':visible');
  }

  function close($dropdown, options = {}) {
    if (!$dropdown.hasClass(OPEN_CLASS)) return;
    $dropdown.removeClass(OPEN_CLASS);
    const $toggle = toggleButton($dropdown);
    $toggle.attr('aria-expanded', 'false');
    $dropdown.trigger('app-dropdown:hide');
    if (options.focusToggle) $toggle.trigger('focus');
  }

  function closeAll(except) {
    $('.js-dropdown.' + OPEN_CLASS).each(function () {
      if (this !== except) close($(this));
    });
  }

  function open($dropdown, options = {}) {
    closeAll($dropdown[0]);
    $dropdown.trigger('app-dropdown:show');
    $dropdown.addClass(OPEN_CLASS);
    toggleButton($dropdown).attr('aria-expanded', 'true');
    if (options.focus === 'first') items($dropdown).first().trigger('focus');
    if (options.focus === 'last') items($dropdown).last().trigger('focus');
  }

  function moveFocus($dropdown, step) {
    const $items = items($dropdown);
    if ($items.length === 0) return;
    const index = $items.index(document.activeElement);
    const next = index === -1 ? (step > 0 ? 0 : $items.length - 1) : (index + step + $items.length) % $items.length;
    $items.eq(next).trigger('focus');
  }

  $(document).on('click', '.js-dropdown-toggle', function (event) {
    event.preventDefault();
    const $dropdown = $(this).closest('.js-dropdown');
    if ($dropdown.hasClass(OPEN_CLASS)) {
      close($dropdown);
    } else {
      open($dropdown);
    }
  });

  // ボタン上の ↓ / ↑ で開いて先頭 / 末尾の項目へ移る
  $(document).on('keydown', '.js-dropdown-toggle', function (event) {
    if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') return;
    event.preventDefault();
    open($(this).closest('.js-dropdown'), { focus: event.key === 'ArrowDown' ? 'first' : 'last' });
  });

  $(document).on('keydown', '.js-dropdown.' + OPEN_CLASS, function (event) {
    const $dropdown = $(this);
    switch (event.key) {
      case 'Escape':
        event.preventDefault();
        close($dropdown, { focusToggle: true });
        break;
      case 'ArrowDown':
        event.preventDefault();
        moveFocus($dropdown, 1);
        break;
      case 'ArrowUp':
        event.preventDefault();
        moveFocus($dropdown, -1);
        break;
      case 'Home':
        event.preventDefault();
        items($dropdown).first().trigger('focus');
        break;
      case 'End':
        event.preventDefault();
        items($dropdown).last().trigger('focus');
        break;
      default:
        break;
    }
  });

  // 項目を選んだら閉じる（data-confirm でキャンセルしたときも閉じてよい）
  $(document).on('click', '.js-dropdown .app-dropdown__item', function () {
    close($(this).closest('.js-dropdown'));
  });

  // メニューの外をクリックしたら閉じる
  $(document).on('click', function (event) {
    if ($(event.target).closest('.js-dropdown').length === 0) closeAll(null);
  });

  // Tab でフォーカスがメニューの外へ出たら閉じる
  $(document).on('focusout', '.js-dropdown.' + OPEN_CLASS, function (event) {
    const $dropdown = $(this);
    if (event.relatedTarget && !$.contains(this, event.relatedTarget)) close($dropdown);
  });

  // 開いたままキャッシュされると、戻るボタンで開いた状態が一瞬見えるため閉じておく
  $(document).on('turbolinks:before-cache', function () {
    closeAll(null);
  });
})();
